'use client';

import React from 'react';

import { useAnalytics } from '@cineamo/composables/src/providers/analyticsProvider';

import { HOME_ENTERTAINMENT_ANCHOR_ID, useHomeEntertainment } from './useHomeEntertainment';

/**
 * "Available at" — where the movie can be watched at home. Same logo-row layout as
 * PartnerLogosSection, but it is the target of the hero CTA in home-entertainment mode.
 */
const HomeEntertainmentSection: React.FC = () => {
    const { track } = useAnalytics();
    const { headline, offers } = useHomeEntertainment();

    if (!offers.length) {
        return null;
    }

    return (
        <section
            className="py-[56px]"
            id={HOME_ENTERTAINMENT_ANCHOR_ID}>
            <h2 className="text-headline-24 lg:text-headline-32 text-center tracking-[0.75px] mb-[24px]">{headline}</h2>
            <div className="flex flex-wrap items-center justify-center gap-[24px] lg:gap-[48px]">
                {offers.map((offer) => {
                    const logo = (
                        // eslint-disable-next-line @next/next/no-img-element
                        <img
                            src={offer.logoUrl}
                            alt={offer.name}
                            className="h-[48px] lg:h-[72px] w-auto max-w-[200px] object-contain"
                        />
                    );

                    if (offer.link) {
                        const href = offer.link.startsWith('http') ? offer.link : `https://${offer.link}`;
                        return (
                            <a
                                key={offer.name}
                                href={href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="transition-opacity hover:opacity-80"
                                onClick={() =>
                                    track('Home Entertainment Offer Clicked', {
                                        offerName: offer.name
                                    })
                                }>
                                {logo}
                            </a>
                        );
                    }

                    return <div key={offer.name}>{logo}</div>;
                })}
            </div>
        </section>
    );
};

export default HomeEntertainmentSection;
